"use strict";

import * as themeA11y from "@shopify/theme-a11y";
import * as Accordions from "components/Accordions";
import * as Overlay from "components/Overlay";
import * as Navigation from "components/Navigation";
import * as Lazyload from "components/Lazyload";
import * as Sliders from "components/Sliders";
import * as Cart from "components/Cart";
import * as MailChimpModal from "components/MailChimpModal";
import * as LiveSearch from "components/LiveSearch";

// Common a11y fixes
themeA11y.focusHash();
themeA11y.bindInPageLinks();
themeA11y.accessibleLinks("a[href]", {
  messages: {
    newWindow: "Opens in a new window.",
    external: "Opens external website.",
    newWindowExternal: "Opens external website in a new window.",
  },
});
document.addEventListener("DOMContentLoaded", async () => {
  Overlay.init();
  Navigation.init();
  Lazyload.init();
  Sliders.init();
  Cart.init();
  Accordions.init();
  MailChimpModal.init();
  LiveSearch.init();
});

// HMR
// if (module.hot) {
//   module.hot.accept();
// }

// if (module.hot) {
//   module.hot.dispose(() => {
//     // reset/undo the behavior/side effect that as possibly enabled/enacted

//   });
// }
